var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56155 2.5H19.4384C20.1267 2.5 20.7267 2.96845 20.8937 3.6362L22.3596 9.5L16.3333 9.5C16.2251 9.5 16.1199 9.46491 16.0333 9.4L12.6 6.825C12.2444 6.55833 11.7556 6.55833 11.4 6.825L7.96667 9.4C7.88012 9.46491 7.77485 9.5 7.66667 9.5H1.64039L3.10634 3.6362C3.27328 2.96845 3.87325 2.5 4.56155 2.5Z",
    fill: "#C3B9D2",
    fillOpacity: 0.16,
    stroke: "#C3B9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V10",
    stroke: "#C3B9D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.5C9 14.2239 9.22386 14 9.5 14H14.5C14.7761 14 15 14.2239 15 14.5V22H9V14.5Z",
    fill: "#C3B9D2",
    fillOpacity: 0.16,
    stroke: "#C3B9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.99faae9465e81139868e4ad7b6fe3a1d.svg";
export { ForwardRef as ReactComponent };